import React, { useEffect, useState } from "react";
import { Table, Modal, Button } from "antd";
import { activateCard, getAllCardRequests } from "../../../apis/cards";
import ActivateCard from "./ActivateCard";
import { Link, useParams } from "react-router-dom";
import { ReactSpreadsheetImport } from "react-spreadsheet-import";

const CardsList = () => {
  const { id } = useParams();
  const [userId, setUserId] = useState(id || "");
  const [searchText, setSearchText] = useState("");
  const [cards, setCards] = useState([]);
  const [filteredCards, setFilteredCards] = useState();
  const [loading, setLoading] = useState(true);
  // const [editingCard, setEditingCard] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [expoToken, setExpoToken] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchCardsList();
  }, []);

  useEffect(() => {
    let filtered = cards;

    if (searchText) {
      const lowerSearch = searchText.toLowerCase();
      filtered = filtered.filter(
        (card) =>
          card.tagId?.toLowerCase().includes(lowerSearch) ||
          String(card.cardNumber).includes(searchText),
      );
    }

    if (userId) {
      filtered = filtered.filter(
        (card) => String(card?.card?.userId) === String(userId),
      );
    }

    setFilteredCards(filtered);
  }, [cards, searchText, userId]);

  const fetchCardsList = async () => {
    try {
      const res = await getAllCardRequests();
      console.log("kdsfksdkf", res?.result);
      setCards(res?.result || []);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setCards([]);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
      sorter: (a, b) => a.id.length - b.id.length,
      width: "10%",
    },
    {
      title: "User ID",
      dataIndex: "card",
      render: (card) => (card?.userId ? `${card?.userId}` : ""),
      width: "20%",
    },
    {
      title: "TagId",
      dataIndex: "tagId",
      width: "20%",
    },
    {
      title: "CardNumber",
      dataIndex: "cardNumber",
      width: "20%",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: "20%",
    },
  ];

  const fields = [
    {
      label: "TagId",
      key: "tagId",
      fieldType: {
        type: "input",
      },
      example: "TAG12345",
      validations: [
        {
          rule: "required",
          errorMessage: "TagId is required.",
        },
      ],
    },
    {
      label: "CardId",
      key: "cardId",
      fieldType: {
        type: "input",
      },
      example: "AE12345R12",
      validations: [
        {
          rule: "required",
          errorMessage: "CardId is required.",
        },
      ],
    },
    {
      label: "CardNumber",
      key: "cardNumber",
      fieldType: {
        type: "input",
      },
      example: "98765",
      validations: [
        {
          rule: "required",
          errorMessage: "CardNumber is required.",
        },
      ],
    },
    {
      label: "Status",
      key: "status",
      fieldType: {
        type: "input",
      },
      example: "Active",
      validations: [
        {
          rule: "required",
          errorMessage: "Status is required.",
        },
      ],
    },
  ];

  const onSubmit = async (values) => {
    setLoading(true);
    const res = await activateCard(null, values);
    if (res.success) {
      fetchCardsList();
      if (res?.result.duplicateRecords)
        console.log(res?.result.duplicateRecords);
    } else {
      console.log(res.message);
    }
    setLoading(false);
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <Link to="/addCards" className="btn add-new btn-primary mb-3">
                Add Cards
              </Link>
              {/*search box*/}
              <div className="d-flex flex-column w-25">
                <label htmlFor="userIdInput" className="form-label">
                  User ID
                </label>
                <input
                  type="text"
                  placeholder="Search by UserId"
                  className="form-control w-20"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                />
              </div>
              <div className="d-flex flex-column w-25">
                <label htmlFor="userIdInput" className="form-label">
                  Search By TagId or Card Number
                </label>
                <input
                  type="text"
                  placeholder="Enter search text"
                  className="form-control w-20"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              <Button
                onClick={() => {
                  setIsOpen(true);
                }}
              >
                UploadFile
              </Button>
              {isOpen && (
                <ReactSpreadsheetImport
                  isOpen={isOpen}
                  onClose={() => {
                    setIsOpen(false);
                  }}
                  onSubmit={(v) => {
                    onSubmit(v.validData);
                  }}
                  fields={fields}
                  translations={{
                    uploadStep: {
                      title: "Upload Cards",
                    },
                  }}
                />
              )}
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    (searchText || userId) && filteredCards?.length > 0
                      ? filteredCards
                      : Array.isArray(cards) && cards.length > 0
                        ? cards
                        : []
                  }
                  rowKey="id"
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Add Notifications Modal */}
      <Modal
        title="Create Card"
        open={isModalVisible}
        footer={null}
        onCancel={handleModalClose}
        width={600}
      >
        {isModalVisible && (
          <ActivateCard expoToken={expoToken} onClose={handleModalClose} />
        )}
      </Modal>
    </>
  );
};

export default CardsList;
